var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"boxs flexCentet"},[_c('img',{attrs:{"src":require("../../../assets/images/newicon/title-left.png"),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.title))]),_c('img',{attrs:{"src":require("../../../assets/images/newicon/title-right.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }